var Global = {
  version: "2.0.0",
};

export default Global;
